import {
	requests
}from '../../../../../api/agent'

export default {
	GetAppealNotice				: (params) => requests.getWithParams('/ReOrgAppeal/getReOrgAppealNotice', params),
	EditOrgAppealNotice			: (params) => requests.post('/ReOrgAppeal/editOrgAppealNotice', params),
	DownloadAppealNoticeFile 	: (params) => requests.getFile('/File/downloadReOrgAppealNoticeFile', params)			
}
